import { Eye, EyeOff } from "lucide-react";
import { forwardRef, useState } from "react";
import { cn } from "@/lib/utils";
import { IconButton } from "./icon-button";
import { Input, type InputProps } from "./input";

export interface InputPasswordProps extends Omit<InputProps, "type"> {
  /** Va al contenedor (ancho, margen), no al `<input>`. */
  className?: string;
}

/**
 * Contrasena con el ojo para mostrarla. El boton es un toggle real
 * (`aria-pressed`) con etiqueta fija: "Mostrar contrasena" presionado significa
 * que se esta mostrando; no hace falta cambiar el texto. `pr-11` reserva el
 * lugar del boton de 44/40.
 */
export const InputPassword = forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ className, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className={cn("relative", className)}>
        <Input ref={ref} type={visible ? "text" : "password"} className="pr-11" {...props} />
        <IconButton
          icono={visible ? EyeOff : Eye}
          aria-label="Mostrar contraseña"
          aria-pressed={visible}
          className="absolute right-0 top-0"
          onClick={() => setVisible((v) => !v)}
        />
      </div>
    );
  },
);
InputPassword.displayName = "InputPassword";
